'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./product/wishlist'));

    // Check if wlpopup parameter is present and open wishlist drawer
    var urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('wlpopup') && urlParams.get('wlpopup') === 'true') {
        var modalElement = document.getElementById('addToWishlistDrawer');
        if (modalElement) {
            $(window).on('load', function () {
                $('#addToWishlistDrawer').modal('show');
                // Clean up URL by removing wlpopup parameter
                urlParams.delete('wlpopup');
                var newUrl = window.location.pathname;
                if (urlParams.toString()) {
                    newUrl += '?' + urlParams.toString();
                }
                if (window.location.hash) {
                    newUrl += window.location.hash;
                }
                window.history.replaceState({}, '', newUrl);
            });
        }
    }
});
